import { GenericResponse, GenericResponseFromJSON } from "@api/client";
import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import AuthService from "core/auth/auth.service";
import { RootState } from "core/store";
import { toast } from "react-toastify";

const BASE_PATH = "../onboarding-api";
const BASE_URL = `https://onboarding-dev.buffettifinance.com/onboarding-api`;

const getConfiguration = (Configuration: any, extra: any, getState: () => RootState) => {
	const c = new Configuration();

	const token = AuthService.getToken();

	const configuration: any = {
		basePath: window.location.hostname === "localhost" ? BASE_URL : BASE_PATH,
		middleware: c.middleware,
		fetchApi: c.fetchApi,
		queryParamsStringify: c.queryParamsStringify,
		headers: {},
		accessToken: () => token,
	};

	return configuration;
};

function Utf8ArrayToStr(array: Uint8Array) {
	var out, i, len, c;
	var char2, char3;

	out = "";
	len = array.length;
	i = 0;
	while (i < len) {
		c = array[i++];
		switch (c >> 4) {
			case 0:
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
			case 6:
			case 7:
				// 0xxxxxxx
				out += String.fromCharCode(c);
				break;
			case 12:
			case 13:
				// 110x xxxx   10xx xxxx
				char2 = array[i++];
				out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
				break;
			case 14:
				// 1110 xxxx  10xx xxxx  10xx xxxx
				char2 = array[i++];
				char3 = array[i++];
				out += String.fromCharCode(
					((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
				);
				break;
		}
	}
	return out;
}

function JSONTryParse(str: string): Object {
	try {
		return JSON.parse(str);
	} catch (e) {
		return {
			error: `JSONTryParse ${e}`,
			error_code: str,
			error_description: str,
		};
	}
}

function isErrorResponseDto(error: Object): boolean {
	return error.hasOwnProperty("message") && error.hasOwnProperty("statusCode");
}

export const decodeError = async (error: Response): Promise<GenericResponse> => {
	let message = error?.statusText;
	let statusCode = error?.status;
	let errorType = undefined;

	if (error?.body) {
		const errorTextReadable = await error.body?.getReader().read();
		if (errorTextReadable.value) {
			const errorTextStr = Utf8ArrayToStr(errorTextReadable.value);
			let errorObject = errorTextStr ? JSONTryParse(errorTextStr) : {};
			if (Array.isArray(errorObject)) {
				errorObject = errorObject[0];
			}
			if (isErrorResponseDto(errorObject)) {
				const errorResponse = GenericResponseFromJSON(errorObject);
				errorResponse.message && (message = errorResponse.message);
				errorResponse.statusCode && (statusCode = errorResponse.statusCode);
				errorType = errorResponse.errorType;
			}
		}
	}

	return {
		message: message || "Servizio momentaneamente non disponibile, riprovare.",
		statusCode: statusCode || 999,
		errorType: errorType,
	};
};

export const errorHandler = async (
	error: any,
	dispatch: ThunkDispatch<RootState, any, AnyAction>,
	decoded?: boolean
) => {
	console.error("errorHandler", error, error.response);
	const errorResponse: any = decoded ? error : await decodeError(error.response);
	console.log("errorResponse", errorResponse);

	toast.error(
		errorResponse?.statusCode == 401
			? "Si è verificato un errore"
			: errorResponse?.message || errorResponse,
		{
			position: "top-center",
			autoClose: 3000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: 0,
		}
	);

	return errorResponse;
};

export default getConfiguration;
